import { render, staticRenderFns } from "./LabelHeaderProductsEditForm.vue?vue&type=template&id=5394b955&scoped=true&"
import script from "./LabelHeaderProductsEditForm.vue?vue&type=script&lang=ts&"
export * from "./LabelHeaderProductsEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./LabelHeaderProductsEditForm.vue?vue&type=style&index=0&id=5394b955&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5394b955",
  null
  
)

export default component.exports